import { render, staticRenderFns } from "./ManifestTableFilters.vue?vue&type=template&id=15a696e2&scoped=true&"
import script from "./ManifestTableFilters.vue?vue&type=script&lang=js&"
export * from "./ManifestTableFilters.vue?vue&type=script&lang=js&"
import style0 from "./ManifestTableFilters.vue?vue&type=style&index=0&id=15a696e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a696e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a696e2')) {
      api.createRecord('15a696e2', component.options)
    } else {
      api.reload('15a696e2', component.options)
    }
    module.hot.accept("./ManifestTableFilters.vue?vue&type=template&id=15a696e2&scoped=true&", function () {
      api.rerender('15a696e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/ManifestTableFilters.vue"
export default component.exports